import React from 'react';
import ConfirmModal from 'js/components/modal/ConfirmModal';
import { Alert } from 'reactstrap';
import { Icon } from 'js/components';

function nodeKindLabel(node) {
  if (!node) {
    return 'node';
  }
  if (node.type === 'team') {
    return 'team';
  }
  if (node.isRoot) {
    return 'organization';
  }
  return 'group';
}

function RenameNodeConfirmDialog({
  node,
  newName,
  intermediateRoot,
  isOpen,
  onCancel,
  onConfirm,
}) {
  const kind = nodeKindLabel(node);

  return (
    <ConfirmModal
      onConfirm={onConfirm}
      onCancel={onCancel}
      isOpen={isOpen}
      confirmButtonLabel="Rename"
      title={`Rename ${kind}?`}
    >
      {intermediateRoot && (
        <Alert color="info">
          <div className="org-change-warning">
            <Icon icon="exclamation-circle" />
            <span>
              This change will affect the organization{' '}
              <strong>{intermediateRoot.name}</strong> and any organizations
              that refer to it.
            </span>
          </div>
        </Alert>
      )}
      <p>
        Rename <strong>{node?.name}</strong> to <strong>{newName}</strong>?
      </p>
    </ConfirmModal>
  );
}

export default RenameNodeConfirmDialog;
